import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { TMapMarkerWrapperProps } from "../../../../types/marker-types";
import ChargingIcon from "../charging-icon/charging-icon";
import styles from "./map-marker-wrapper.module.less";
import { useCallback } from "react";
import MapMarker from "../map-marker/map-marker";

export const MapMarkerWrapper = ({
  position,
  title,
  hasElectricalCharging,
  stationCode,
  markerType,
  isSelected,
  withoutAdvancedMarker,
  onClickMarker,
}: TMapMarkerWrapperProps) => {
  const handleClick = useCallback(() => onClickMarker && onClickMarker(stationCode), [onClickMarker, stationCode]);

  const inner = (
    <div className={styles.wrapper}>
      {hasElectricalCharging && (
        <div className={styles.chargingIconWrapper}>
          <ChargingIcon />
        </div>
      )}
      <div className={[styles.selectedMarkerWrapper, isSelected ? styles.visible : ""].join(" ")}>
        <svg width="40" height="44" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.7899 41.0295L17.8328 41.0783L17.8787 41.1242C19.0503 42.2958 20.9497 42.2958 22.1213 41.1242L22.1672 41.0783L22.2101 41.0295L24.8698 38H32C35.3137 38 38 35.3137 38 32V8C38 4.68629 35.3137 2 32 2H8C4.68629 2 2 4.68629 2 8V32C2 35.3137 4.68629 38 8 38H15.1302L17.7899 41.0295Z"
            stroke="black"
            strokeWidth="2"
          />
        </svg>
      </div>
      <MapMarker markerType={markerType} />
    </div>
  );

  if (withoutAdvancedMarker) {
    return inner;
  }

  return (
    <AdvancedMarker title={title} key={stationCode} onClick={handleClick} position={position}>
      {inner}
    </AdvancedMarker>
  );
};

export default MapMarkerWrapper;
